const mask = {
  phoneNumber: '### ###-####',
  year: '####',
  postalCode: 'A#A #A#',
};

export { mask };
